import type { MutableRefObject } from "react";
import { useEffect } from "react";

export const useElementIntersectionOnce = (
  elementRef: MutableRefObject<HTMLElement>,
  onIntersection: () => void,
  threshold = 0.25
) => {
  useEffect(() => {
    const intersectionCallback = (entries: IntersectionObserverEntry[], observer: IntersectionObserver) =>
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          onIntersection();
          observer.unobserve(entry.target);
        }
      });

    const observer = new IntersectionObserver(intersectionCallback, { threshold });
    if (elementRef.current) {
      observer.observe(elementRef.current);
    }

    return () => {
      observer.disconnect();
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
